import React from 'react';
import { Clock, ShieldCheck, Download, CreditCard } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
interface OfferSectionProps {
  timeLeft: string;
  price: string;
  comparePrice: string;
}
export function OfferSection({
  timeLeft,
  price,
  comparePrice
}: OfferSectionProps) {
  return <section id="oferta" className="py-24 px-4 bg-gradient-to-b from-[#1a0505] to-[#0a0a0a] border-t border-[#cc2200]/30" data-id="element-105">
      <div className="max-w-4xl mx-auto text-center" data-id="element-106">
        {/* Stamp */}
        <div className="stamp-text text-3xl md:text-4xl mb-8 transform rotate-3 inline-block border-4" data-id="element-107">
          Casos Criminales
        </div>

        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 font-['Special_Elite']" data-id="element-108">
          La oferta que no puedes ignorar
        </h2>

        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-109">
          Normalmente, cada uno de estos casos se vende por separado. Pero
          sabemos que una vez que resuelvas el primero, tendrás sed de justicia.
        </p>

        {/* Price Box */}
        <div className="bg-[#c8b89a] text-[#0a0a0a] p-8 md:p-12 rounded-sm shadow-2xl max-w-2xl mx-auto relative overflow-hidden mb-12" data-id="element-110">
          {/* Ribbon */}
          <div className="absolute top-0 right-0 bg-[#cc2200] text-white text-xs font-bold px-8 py-1 transform rotate-45 translate-x-8 translate-y-4 shadow-md" data-id="element-111">
            AHORRA 75%
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-8" data-id="element-112">
            <div className="text-center" data-id="element-113">
              <p className="text-gray-600 font-bold text-lg line-through decoration-red-600 decoration-2" data-id="element-114">
                Precio Normal: {comparePrice}
              </p>
            </div>
            <div className="text-5xl md:text-7xl font-bold text-[#cc2200] font-['Special_Elite']" data-id="element-115">
              {price}
            </div>
            <div className="text-left" data-id="element-116">
              <p className="font-bold text-xl" data-id="element-117">POR LOS 4 CASOS</p>
              <p className="text-sm opacity-80" data-id="element-118">
                Pago único. Acceso de por vida.
              </p>
            </div>
          </div>

          <p className="text-sm font-semibold mb-8 italic border-t border-black/10 pt-4" data-id="element-119">
            "Es menos de lo que cuesta una cena rápida, pero te ofrece más de 12
            horas de entretenimiento inmersivo."
          </p>

          <a href="https://www.mododetective.store/cart/47848790524118:1" onClick={() => trackAddToCart()} className="block w-full bg-[#cc2200] hover:bg-[#aa1100] text-white text-xl md:text-2xl font-bold py-5 px-6 rounded-sm shadow-lg transition-all transform hover:scale-[1.02] border-2 border-[#ff4422] uppercase font-['Special_Elite'] mb-4 text-center" data-id="element-120">
            ¡SÍ! QUIERO MIS 4 EXPEDIENTES AHORA
          </a>

          <p className="text-xs text-[#333] font-mono" data-id="element-121">
            Descarga inmediata en PDF · Compatible con Tablet, Móvil u Ordenador
          </p>
        </div>

        {/* Urgency */}
        <div className="inline-flex items-center gap-2 text-[#cc2200] font-bold font-mono bg-[#cc2200]/10 px-4 py-2 rounded-full mb-12 animate-pulse" data-id="element-122">
          <Clock className="w-4 h-4" data-id="element-123" />
          <span data-id="element-124">LA OFERTA 4X1 EXPIRA EN: {timeLeft}</span>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-6 text-gray-400 text-sm font-bold uppercase tracking-wider" data-id="element-125">
          <div className="flex items-center gap-2" data-id="element-126">
            <CreditCard className="w-5 h-5 text-[#c8b89a]" data-id="element-127" />
            Pago 100% Seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-128">
            <Download className="w-5 h-5 text-[#c8b89a]" data-id="element-129" />
            Descarga Inmediata
          </div>
          <div className="flex items-center gap-2" data-id="element-130">
            <ShieldCheck className="w-5 h-5 text-[#c8b89a]" data-id="element-131" />
            Garantía 30 Días
          </div>
        </div>
      </div>
    </section>;
}